// Common HTML entities that can leak in if upstream/downstream re-encodes the text.
const HTML_ENTITIES: Record<string, string> = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&apos;": "'",
    "&#39;": "'",
};

// Unicode characters frequently mangled by downstream UTF-8/Latin-1 mishandling.
// Replaced with ASCII equivalents so the dispatched payload survives intact.
const UNICODE_REPLACEMENTS: Record<string, string> = {
    "‘": "'", // left single quote
    "’": "'", // right single quote / apostrophe
    "“": '"', // left double quote
    "”": '"', // right double quote
    "–": "-", // en dash
    "—": "-", // em dash
    "‑": "-", // non-breaking hyphen
    "…": "...", // ellipsis
    " ": " ", // non-breaking space
};

const HTML_ENTITY_PATTERN = new RegExp(Object.keys(HTML_ENTITIES).join("|"), "g");
const UNICODE_PATTERN = new RegExp(Object.keys(UNICODE_REPLACEMENTS).join("|"), "g");

/**
 * Normalize session summary text before dispatching to EIP/DART.
 * Decodes HTML entities and replaces commonly-mangled Unicode punctuation
 * with ASCII equivalents so downstream encoding mishandling cannot corrupt
 * the characters in the partner tool (OPUS) display. Real letters with
 * diacritics (ñ, é, ó) are preserved.
 */
export const sanitizeRemarkText = (text: string): string => {
    if (!text) return text;
    return text
        .replace(HTML_ENTITY_PATTERN, (match) => HTML_ENTITIES[match] ?? match)
        .replace(UNICODE_PATTERN, (match) => UNICODE_REPLACEMENTS[match] ?? match);
};
